export default __webpack_public_path__ + "static/media/Audit_RBAC.57d5ee0b.png";